import React from 'react';

interface TenderInfoCardProps {
  title: any;
  mainInfo: any;
  additionalInfo: any;
  selectTextClass?: string;
}

export const TenderInfoCard: React.FC<TenderInfoCardProps> = ({ title, mainInfo, additionalInfo, selectTextClass }) => {
  return (
    <div className="card w-full min-w-40 max-w-full rounded-lg bg-base-100">
      <div className="card-body">
        <div className="truncate text-sm font-normal text-primary opacity-80">{title}</div>
        <div className={`${selectTextClass} line-clamp-2 text-base font-medium text-primary`}>{mainInfo}</div>
        <div className="truncate text-xs font-normal text-primary opacity-60">{additionalInfo}</div>
      </div>
    </div>
  );
};
